import { useEffect, useState } from 'react';

import { SRSAvailability } from '../../auth/types/user';
import { useWebSocket } from '../../shared/hooks/useWebSocket';

interface IUseLiveSrsAvailabilities {
  getSrsLiveStatus: (employeeId: number, currentStatus: string) => string;
}

type Message = {
  topic: string;
  data: {
    srsAvailabilities: SRSAvailability[];
  }[];
};

export const useLiveSrsAvailabilities = (): IUseLiveSrsAvailabilities => {
  const [srsStatuses, setSrsStatuses] = useState<SRSAvailability[]>([]);

  const srsTopic = 'srs_availabilities';
  const { lastJsonMessage: srsStatusChange } = useWebSocket<Message>({ topic: srsTopic });

  useEffect(() => {
    if (srsStatusChange && srsStatusChange.topic === srsTopic) {
      if (!srsStatuses.length) {
        setSrsStatuses(srsStatusChange.data.flatMap((data) => data.srsAvailabilities));
      } else {
        srsStatusChange.data.forEach((data) => {
          const { employeeId, status } = data.srsAvailabilities[0];

          updateEmployeeStatus(employeeId, status);
        });
      }
    }
  }, [srsStatusChange]);

  const updateEmployeeStatus = (employeeId, status) => {
    let currentSrsStatuses = srsStatuses;

    if (srsStatuses.some((e) => e.employeeId === employeeId)) {
      currentSrsStatuses = srsStatuses.map((e: SRSAvailability) => ({
        ...e,
        ...(e.employeeId === employeeId && { status: status }),
      }));
    } else {
      currentSrsStatuses = [
        ...srsStatuses,
        {
          id: employeeId,
          employeeId,
          status,
        },
      ];
    }

    setSrsStatuses(currentSrsStatuses);
  };

  const getSrsLiveStatus = (employeeId: number, currentStatus: string) => {
    const srsLiveStatus = srsStatuses.find((srsStatus) => srsStatus.employeeId === employeeId);

    return srsLiveStatus ? srsLiveStatus.status : currentStatus;
  };

  return {
    getSrsLiveStatus,
  };
};
